<script lang="ts" >
    import type {HTMLInputAttributes} from 'svelte/elements'

    interface $$Props extends HTMLInputAttributes {
        unit?: string,
        numberInput?: HTMLInputElement,
    }
    export let value: $$Props["value"] = undefined
    export let unit: $$Props["unit"] = undefined
    export let max: $$Props["max"] = undefined
    export let min: $$Props["min"] = undefined
    export let disabled: $$Props["disabled"] = false
    let className: $$Props["class"] = undefined
    export {className as class}

    export let numberInput: HTMLInputElement = undefined

    function dispatchChangeEvent() {
        numberInput.dispatchEvent(new Event('change', { bubbles: true }))
    }

    function handleIncrease() {
        let changed = false
        numberInput.stepUp()
        numberInput.value = Math.min(Number(numberInput.value), Number(max)).toString()
        changed = value != Number(numberInput.value)
        value = Number(numberInput.value) 
        if(changed) dispatchChangeEvent()
    }
    function handleDecrease() {
        let changed = false
        numberInput.stepDown()
        numberInput.value = Math.max(Number(numberInput.value), Number(min)).toString()
        changed = value != Number(numberInput.value)
        value = Number(numberInput.value) 
        if (changed) dispatchChangeEvent()
    }

    // TODO: Prevent max and min onchange

</script>

<div class={className} class:disabled>
    <div class="flex overflow-hidden">
        <div class="date-info inline-flex items-baseline py-1 px-2 border border-r-0 border-slate-400 rounded-s-lg hover:cursor-text gap-1">
            <input class="number-input border-none text-xerteal-700 focus-visible:outline-none text-3xl w-full" {...$$restProps} type="number" bind:value bind:this={numberInput} on:change/>
            <span class="text-slate-400 text-lg">{unit ? unit : ""}</span>
        </div>
        <div class="flex flex-col">
            <button type="button" class="input-button flex bg-xerteal-400 rounded-tr-lg border border-slate-400 border-l-0 border-b-0 shadow-xerteal-300/40 flex-1 hover:bg-xerteal-500 transition-all" on:click={handleIncrease}>
                <i class="text-white fa-regular fa-plus text-sm"></i>
            </button>
            <button type="button" class="input-button flex bg-xerteal-400 rounded-br-lg border border-slate-400 border-l-0 border-t-0 shadow-xerteal-300/50 flex-1 hover:bg-xerteal-500 transition-all" on:click={handleDecrease}>
                <i class="text-white fa-regular fa-minus text-sm"></i>
            </button>
        </div>
    </div>
</div>

<style lang="scss">
    .month-date {
        box-shadow: 0px 1px 2px 0 rgb(0 0 0 / 0.1);
    }
    .date-info {
        box-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.1);
    }
    .input-button {
        box-shadow: inset 0px 1px 0px 0 var(--tw-shadow-color), -1px 0px 3px rgb(0 0 0 /0.15);

        &:active {
            box-shadow: inset 0px -1px 0px 0 var(--tw-shadow-color), inset 1px 1px 1px rgb(0 0 0 /0.1);
        }
    }
    .number-input {

        // Removes the arrows from the number input box
        -moz-appearance: textfield;
        &::-webkit-outer-spin-button, &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
    }
    .disabled {
        pointer-events: none;
        button {
            background-color: #b4b4b4 !important;
        }
    }
</style>
